/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllStoreGroups } from '../fn/all-store-groups/get-all-store-groups';
import { GetAllStoreGroups$Params } from '../fn/all-store-groups/get-all-store-groups';
import { StoreGroupDetailsResponse } from '../models/store-group-details-response';

@Injectable({ providedIn: 'root' })
export class AllStoreGroupsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllStoreGroups()` */
  static readonly GetAllStoreGroupsPath = '/store-groups';

  /**
   * Gets all store groups details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllStoreGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStoreGroups$Response(params: GetAllStoreGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StoreGroupDetailsResponse>>> {
    return getAllStoreGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all store groups details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllStoreGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStoreGroups(params: GetAllStoreGroups$Params, context?: HttpContext): Observable<Array<StoreGroupDetailsResponse>> {
    return this.getAllStoreGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<StoreGroupDetailsResponse>>): Array<StoreGroupDetailsResponse> => r.body)
    );
  }

}
